import styled from 'styled-components'

const ScrollableContent = styled.div`
  width: 100%;
  flex: 1;
  overflow-y: auto;
`

const FullScreenContainer = styled.div<{
  align?: 'top' | 'center'
}>`
  display: flex;
  justify-content: ${({ align }) =>
    align === 'center' ? 'center' : 'flex-start'};
  flex-direction: column;
  height: 100%;
  flex: 1;
`

const ButtonGroup = styled.div`
  flex: 0;
  display: flex;
  padding-top: 32px;
  gap: 16px;
  flex-flow: column;
`

export { ButtonGroup, FullScreenContainer, ScrollableContent }
